export default function parseJsonString(str) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  try {
    return JSON.parse(str);
  } catch (e) {
    return defaultValue;
  }
}